import { render, staticRenderFns } from "./MoreInfo.template.vue?vue&type=template&id=2076d7b2&scoped=true&"
var script = {}
import style0 from "./MoreInfo.template.vue?vue&type=style&index=0&id=2076d7b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076d7b2",
  null
  
)

export default component.exports